import { Component, Input, OnInit } from "@angular/core";
import { DashboardMultiStationService } from "../../dashboard-multistation.service";
import { Router } from "@angular/router";

@Component({
	selector: "caass-ms-blocked-attempt-table",
	templateUrl: "./ms-blocked-attempt-table.component.html",
	styleUrls: ["./ms-blocked-attempt-table.component.css"],
})
export class MsBlockedAttemptTableComponent implements OnInit {
	constructor(private visitorService: DashboardMultiStationService, private router: Router) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedVisitorPassDetail: any;
	@Input() lstVisitorPassDetail: any = [];
	@Input() loading: boolean = false;

	lstHasPhotoDesc: any = [];
	lstFacilityLocationName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'HasPhotoDesc', header: 'Photo' },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "LogDTDesc", header: "Date/Time" },
		{ field: "FacilityLocationName", header: "Location" },
	];

	ImageDict: Map<number, string> = new Map(); //Dictionary that matches Visitor Pass IDs to base64 of image
	lstImageCalls: any = [];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		if (this.lstVisitorPassDetail == undefined || this.lstVisitorPassDetail.length == 0) {
			this.lstHasPhotoDesc = [];
			this.lstFacilityLocationName = [];
			return;
		} else {
			this.lstHasPhotoDesc = Array.from(new Set(this.lstVisitorPassDetail.map((item: any) => item.HasPhotoDesc))).sort();
			this.lstFacilityLocationName = Array.from(new Set(this.lstVisitorPassDetail.map((item: any) => item.FacilityLocationName))).sort();
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onRowSelect(val) {
		this.SelectedVisitorPassDetail = val.data;
	}
	onRowUnselect(val) {
		this.SelectedVisitorPassDetail = null;
	}
	onRowDblClick(VisitorPassDetail) {
		this.SelectedVisitorPassDetail = VisitorPassDetail;

		document.getElementById("Link" + VisitorPassDetail.VisitorPassDetailID).click();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	GetPhotoData(VisitorPassID) {
		if (this.ImageDict.has(VisitorPassID)) {
			return this.ImageDict.get(VisitorPassID);
		} else {
			var found = false;

			for (var z = 0; z < this.lstImageCalls.length; z++) {
				var next = this.lstImageCalls[z];

				if (next == VisitorPassID) {
					found = true;
					break;
				}
			}

			if (found) {
				return "assets\\images\\loading.gif";
				//return this.ImageDict.get(-1); //Already made the webservice call
			} else {
				//Make the webservice call 1 time
				this.lstImageCalls = [...this.lstImageCalls, VisitorPassID]; //Add to list of calls made

				var result = this.visitorService.GetPhotoByVisitorPass(VisitorPassID);
				result.subscribe(
					(response: any) => {
						this.ImageDict.set(VisitorPassID, response.VisitorPhoto);

						return response.VisitorPhoto;
					},
					(error) => {
						return this.ImageDict.get(-1); //Missing Photo
					}
				);
			}
		}
	}
	////////////////////////////////////////////
}
